<ng-container *ngIf="!loadingSpinner">
  <div class="suggestion-header-title">
    <div class="date-title">
      {{nextWeekStartFormatted}} - {{nextWeekEndFormatted}}
    </div>
    <div class="sort-tool-bar">
      <div class="sort-label">
        Sort By:
      </div>
      <div class="sort-dropdown">
        <p-dropdown [options]="sortButtons" [(ngModel)]="chosenSortButton" class="group-dropdown"
                    (onChange)="sortByDate()"
                    placeholder="Sort By"
                    optionLabel="title" appendTo="body" panelStyleClass="p-sort-dropdown-panel"
        ></p-dropdown>
      </div>
    </div>
  </div>
  <div class="day-blocks">
    <app-logistic-planning-day *ngFor="let day of week" [day]="day"></app-logistic-planning-day>
  </div>

  <div class="action-buttons">
    <div class="action-label">
      <span class="refresh-title"
            *ngIf="logisticSuggestion.lastRunFinish">Last Refresh: {{logisticSuggestion.lastRunFinish | date: 'MMMM dd'}}
        at {{logisticSuggestion.lastRunFinish | date: 'hh:mm'}}</span>

      <span class="status-title">
      Status:
      <span *ngIf="logisticSuggestion.status === 'RUNNING'">Refreshing...</span>
      <span *ngIf="logisticSuggestion.status === 'SUCCESS'">Success</span>
      <span *ngIf="logisticSuggestion.status === 'FAILED'">Failed</span>
      <span *ngIf="logisticSuggestion.status === 'CANCELLED'">Canceled</span>
    </span>
    </div>
    <button class="recalc-button" *ngIf="logisticSuggestion.stale" mat-button (click)="reCalculate()"
            [disabled]="logisticSuggestion.status === 'RUNNING'">
      <ng-container *ngIf="logisticSuggestion.status !== 'RUNNING'">Re-Calculate</ng-container>
      <lib-mini-progress-spinner *ngIf="logisticSuggestion.status === 'RUNNING'"></lib-mini-progress-spinner>
    </button>
    <button class="approve-button" *ngIf="!logisticSuggestion.stale" mat-button (click)="approveSuggestions()"
            [disabled]="approveLoading">
      <ng-container *ngIf="!approveLoading">Accept</ng-container>
      <lib-mini-progress-spinner *ngIf="approveLoading"></lib-mini-progress-spinner>
    </button>
  </div>
</ng-container>

<lib-progress-spinner *ngIf="loadingSpinner"></lib-progress-spinner>



